import { z } from "zod";

export const addCustomerConnectSchema = z.object({
  email: z
    .string({ required_error: "Please enter email" })
    .trim()
    .nonempty({ message: "Email is required" })
    .email({ message: "Enter a valid email" }),

  first_name: z
    .string()
    .trim()
    .nonempty({ message: "First Name is required" })
    .regex(/^[A-Za-z]+$/, {
      message: "First Name must contain only letters (no numbers or spaces)",
    }),

  last_name: z
    .string()
    .trim()
    .nonempty({ message: "Last Name is required" })
    .regex(/^[A-Za-z]+$/, {
      message: "Last Name must contain only letters (no numbers or spaces)",
    }),

  mobile: z
    .string({ required_error: "Please enter your mobile number" })
    .trim().min(10)
    .regex(/^\d{10}$/, { message: "Mobile number must be exactly 10 digits" }),

  language: z
    .string()
    .trim()
    .nonempty({ message: "Language is required" }),
});

export type CustomerConnect = z.infer<typeof addCustomerConnectSchema>;

export const addCustomerConnectCaneraBankSchema = z.object({


  first_name: z
    .string()
    .trim()
    .nonempty({ message: "First Name is required" })
    .regex(/^[A-Za-z]+$/, {
      message: "First Name must contain only letters (no numbers or spaces)",
    }),

  last_name: z
    .string()
    .trim()
    .nonempty({ message: "Last Name is required" })
    .regex(/^[A-Za-z]+$/, {
      message: "Last Name must contain only letters (no numbers or spaces)",
    }),

  mobile: z
    .string({ required_error: "Please enter your mobile number" })
    .trim()
  .nonempty("Mobile number is required")
  .regex(/^\+?[1-9]\d{6,14}$/, "Enter a valid mobile number"),
  language: z
    .string()
    .trim()
    .nonempty({ message: "Language is required" }),
});

export type CustomerConnectCaneraBank = z.infer<typeof addCustomerConnectCaneraBankSchema>;
